export default "/memento-mori/assets/3c03325517c2a55852bd0fe265e584b8.mp3";